 
import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import {
  CardComponent,
  NoDataTable,
  Table,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import careQualityMessages from '../core-utils/messages/careQualityMessages';
// import { getInfoIcon } from '../core-utils/helper-utils/infoIconHelper';
import { scrollBarStyles } from '../core-utils/messages/CommonConstants';

const CareQualityMeasuresTable: React.FC<reportProps> = ({ data }) => {
  const [measures, setMeasures] = useState<any>([]);
  const cardMessages = careQualityMessages.CARE_QUALITY_PAGE.CARDS;

  const useStyles = makeStyles()({
    headerText: {
      fontSize: '12px',
      fontHeight: '12px',
      fontWeight: 500,
      color: patientAccessTheme.palette.text.highemphasis,
    },
    tableHeader: {
      height: '38px',
      backgroundColor: patientAccessTheme.palette.grey[100],
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '&:first-child': {
        paddingLeft: '20px',
      },
      textAlign: 'left',
    },
    tableRow: {
      height: '42px',
      padding: '0px',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '&:first-child': {
        paddingLeft: '38px',
      },
    },
    chip: {
      height: '25px',
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '5px 8px',
    },
  });

  const { classes } = useStyles();

  // const getChipComponent = (
  //   chipType: 'Needs Intervention' | 'Good' | 'Average' | 'NA',
  //   label?: string | React.JSX.Element,
  // ) => {
  //   switch (chipType) {
  //     case 'Needs Intervention':
  //       return (
  //         <div
  //           className={classes.chip}
  //           style={{
  //             width: label ? '120px' : '150px',
  //             backgroundColor: patientAccessTheme.palette.AIQChips?.background1,
  //             border: '0.3px solid rgba(226, 84, 84, 0.5)',
  //           }}
  //         >
  //           <Typography
  //             fontSize="12px"
  //             lineHeight="15px"
  //             fontType="medium"
  //             textColor={patientAccessTheme.palette.AIQChips?.textColor1}
  //           >
  //             {label ?? 'Needs Intervention'}
  //           </Typography>
  //         </div>
  //       );
  //     case 'Good':
  //       return (
  //         <div
  //           className={classes.chip}
  //           style={{
  //             width: label ? '120px' : '150px',
  //             backgroundColor: patientAccessTheme.palette.AIQChips?.background2,
  //             border: '0.3px solid rgba(0, 130, 114, 0.5)',
  //           }}
  //         >
  //           <Typography
  //             fontSize="12px"
  //             lineHeight="15px"
  //             fontType="medium"
  //             textColor={patientAccessTheme.palette.AIQChips?.textColor2}
  //           >
  //             {label ?? 'Good'}
  //           </Typography>
  //         </div>
  //       );

  //     case 'Average':
  //       return (
  //         <div
  //           className={classes.chip}
  //           style={{
  //             width: label ? '120px' : '150px',
  //             backgroundColor:
  //               patientAccessTheme.palette.AIQChips?.background15,
  //             border: '0.3px solid' + patientAccessTheme.palette.primary[500],
  //           }}
  //         >
  //           <Typography
  //             fontSize="12px"
  //             lineHeight="15px"
  //             fontType="medium"
  //             textColor={patientAccessTheme.palette.primary[500]}
  //           >
  //             {label ?? 'Average'}
  //           </Typography>
  //         </div>
  //       );

  //     default:
  //       return (
  //         <div
  //           className={classes.chip}
  //           style={{
  //             width: label ? '120px' : '150px',
  //             backgroundColor: patientAccessTheme.palette.grey[300],
  //             border: '0.3px solid' + patientAccessTheme.palette.grey[900],
  //           }}
  //         >
  //           <Typography
  //             fontSize="12px"
  //             lineHeight="15px"
  //             fontType="medium"
  //             textColor={patientAccessTheme.palette.grey[900]}
  //           >
  //             {label ?? 'na'}
  //           </Typography>
  //         </div>
  //       );
  //   }
  // };

  const measuresColumns = [
    {
      Header: (
        <Typography className={classes.headerText} style={{ width: '420px' }}>
          {'Care Gap'}
        </Typography>
      ),
      Footer: 'MEASURES',
      accessor: 'individualMeasure',
      sticky: 'left',
      Cell: ({ value }: any) => <div>{value}</div>,
    },
    // {
    //   Header: (
    //     <Typography
    //       className={classes.headerText}
    //       style={{ width: '55px', display: 'flex' }}
    //     >
    //       {'Rate'}
    //       {getInfoIcon(
    //         'Percentage of compliant population out of eligible population for the measure',
    //         '',
    //         '',
    //         true,
    //       )}
    //     </Typography>
    //   ),
    //   Footer: 'RATE',
    //   accessor: 'rate',
    //   sticky: 'left',
    //   cellType: 'none',
    //   icon: 'none',
    //   Cell: ({ value }: any) => <div>{value}%</div>,
    // },
    // {
    //   Header: (
    //     <Typography
    //       className={classes.headerText}
    //       style={{ width: '95px', display: 'flex' }}
    //     >
    //       {'Target Rate'}
    //       {getInfoIcon(
    //         'National benchmark levels for the measure',
    //         '',
    //         '',
    //         true,
    //         { width: '200px', left: '60px' },
    //         { left: '99px' },
    //       )}
    //     </Typography>
    //   ),
    //   Footer: 'Target Rate',
    //   accessor: 'nationalScore',
    //   sticky: 'left',
    //   cellType: 'none',
    //   icon: 'none',
    //   Cell: ({ value }: any) => <div>{value}%</div>,
    // },
    {
      Header: (
        <Typography className={classes.headerText} style={{ width: '45px' }}>
          {'Eligible'}
        </Typography>
      ),
      Footer: 'Eligible Members',
      accessor: 'eligibleCount',
      sticky: 'left',
      cellType: 'none',
      icon: 'none',
    },
    {
      Header: (
        <Typography className={classes.headerText} style={{ width: '60px' }}>
          {'Compliant'}
        </Typography>
      ),
      Footer: 'Met Members',
      accessor: 'measureMetCount',
    },
    {
      Header: (
        <Typography className={classes.headerText} style={{ width: '90px' }}>
          {'Non-Compliant'}
        </Typography>
      ),
      Footer: 'Unmet Members',
      accessor: 'measureNotMetCount',
    },
    {
      Header: (
        <Typography className={classes.headerText} style={{ width: '100px' }}>
          {'Not Enough Data'}
        </Typography>
      ),
      Footer: 'Not Enough Data',
      accessor: 'measureNotEnoughDataCount',
    },
    // {
    //   Header: (
    //     <Typography
    //       className={classes.headerText}
    //       style={{ width: '155px', display: 'flex' }}
    //     >
    //       {'Current Performance'}
    //       {getInfoIcon(
    //         'As percentage of average national performance',
    //         '',
    //         '',
    //         true,
    //         { width: '200px', left: '-20px' },
    //         { left: '155px' },
    //       )}
    //     </Typography>
    //   ),
    //   Footer: 'Current Performance',
    //   accessor: 'measureScore',
    //   icon: 'none',
    //   Cell: ({ value, row }: any) => (
    //     <div>
    //       {value === 'NA'
    //         ? getChipComponent(value, 'na')
    //         : getChipComponent(row?.original?.rank, value)}
    //     </div>
    //   ),
    // },
  ];

  const formatCareQualityMeasures = (data: any) => {
    const keywords = new Set([
      'Immunization',
      'Ambulatory Health Services',
      'Screening',
      'Primary Care',
    ]);

    const requiredMeasures = new Set([
      'Cervical Cancer Screening',
      'Breast Cancer Screening',
      'Colorectal Cancer Screening',
      'Immunizations For Adolescents',
      'Controlling High Blood Pressure',
      'Ambulatory Health Services',
    ]);

    const filteredMeasures: any[] = [];

    data.forEach((subMeasure: any) => {
      subMeasure.individualMeasures.forEach((measure: any) => {
        if (
          measure.eligibleCount > 0 &&
          (Array.from(requiredMeasures).some((keyword) =>
            measure.individualMeasure.includes(keyword),
          ) ||
            Array.from(keywords).some((keyword) =>
              measure.individualMeasure.includes(keyword),
            ))
        ) {
          filteredMeasures.push(measure);
        }
      });
    });

    filteredMeasures.sort((a, b) => b.measureMetCount - a.measureMetCount);
    return filteredMeasures.slice(0, 10);
  };

  useEffect(() => {
    setMeasures(formatCareQualityMeasures(data?.careQualityDistribution));
  }, []);
  return (
    <CardComponent
      title={cardMessages.CARE_QUALITY_DISTRIBUTION.TITLE}
      width="100%"
      body={
        <>
          {measures.length > 0 ? (
            <>
              <Table
                classNameForTableHeaderRowTop={classes.tableHeader}
                classNameForTableDataRow={classes.tableRow}
                classNameForTableHeader={classes.tableHeader}
                columns={measuresColumns}
                data={measures}
                onHoverRowData={() => {}}
                controlledPageIndex={0}
                isManualPagination={true}
                tableWidth="100%"
                tableWrapStyles={{ overflow: 'visible' }}
              />
            </>
          ) : (
            <NoDataTable
              height={'100%'}
              width={'100%'}
              content={'No Measures available'}
            />
          )}
        </>
      }
      mainGridStyles={{ overflowX: 'scroll', ...scrollBarStyles }}
    />
  );
};
export default CareQualityMeasuresTable;
